import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.GeneratePdf.IRequest;
type Response = Api.Core.StatementBalance.GeneratePdf.IResponse;
type Headers = Api.Core.StatementBalance.GeneratePdf.IHeaders;
const url = '/api/DealerManagement/StatementBalance/GeneratePdf/:id';
export default async function statementBalanceGeneratePdfApi(id: number): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
}
